import dompurify from 'dompurify'

import { cn } from '@/lib/utils'

export interface VisaBulletinGuideTextProps {
  text: string | null
}

export const VisaBulletinGuideText = ({ text }: VisaBulletinGuideTextProps) => {
  if (!text) {
    return null
  }

  const sanitizedText = dompurify.sanitize(text)

  return (
    <ul className={cn('list-outside list-disc', 'mb-2.5 ml-5', 'text-xs font-normal leading-[18px] text-[#0b0b0b]')}>
      <li
        dangerouslySetInnerHTML={{ __html: sanitizedText }}
        className={cn('[&>a]:text-[#325AFF] [&>a]:hover:underline')}
      />
    </ul>
  )
}
